import type { Presale } from "@/types/presale"

export const getPresale = (item?: Presale) => {
  return {
    id: item?.id ?? "",
    courseId: item?.courseId ?? "",
    courseName: item?.courseName ?? item?.courseTitle ?? "",
    courseTitle: item?.courseTitle ?? item?.courseName ?? "",
    courseStatus: item?.courseStatus ?? "",
    coursePresalesEnabled: item?.coursePresalesEnabled ?? false,
    discountType: item?.discountType ?? "PERCENT",
    discountValue: item?.discountValue ?? 0,
    preSalesPrice: item?.preSalesPrice ?? 0,
    limit: item?.limit ?? null,
    counterOffset: item?.counterOffset ?? 0,
    displayCount: item?.displayCount ?? 0,
    spotsLeft: item?.spotsLeft ?? null,
    notifyWaitlist: item?.notifyWaitlist ?? true,
    banner: item?.banner ?? "",
    startDate: item?.startDate ?? "",
    endDate: item?.endDate ?? "",
    createdAt: item?.createdAt ?? "",
    updatedAt: item?.updatedAt ?? "",
  }
}

export const getPresalesList = (data?: Presale[]) => {
  return data?.length ? data.map((item) => getPresale(item)) : []
}
